export function getPaymentFailureMessage(error?: string | null): string {
  return error === "payment_method_is_detached"
    ? "Сохранённый способ оплаты больше недоступен. Попробуйте оплатить другим способом."
    : "Попробуйте ещё раз или выберите другой способ оплаты."
}
